<template>
        <div class="row" >
            <div class="col-12 col-md-6 col-xl-6">
                <img class="paste-image-icon"  alt="" src="../../../assets/images/subscribe-image.png" />
            </div>

            <div class="col-12 col-md-6 col-xl-6 container">
                    <div class="subscribe">Créer un compte</div>


                    <div class="go-login-first">Vous avez déjà un compte ?
                        <router-link to="/login">
                            <span class="go-login">Se connecter</span>
                        </router-link>
                    </div>

                    <router-link to="/signup" class="button1">
                        <div class="getStarted1">Mail</div>
                    </router-link>

                    <div v-if="showOauth" class="ou text-center">Ou</div>

                    <div v-if="showOauth" class="small-box-container" @click="getUrlGoogle()">
                        <img class="icon-class" alt="" src="../../../assets/images/flat-color-icons_google.svg" />
                        <div class="sign-up-with">Continuer avec Google</div>
                    </div>

                    <div v-if="showOauth" class="facebook-small-box-container mt-4"  @click="getUrlFacebook()">
                        <img class="icon-class" alt="" src="../../../assets/images/facebook-login.svg" />
                        <div class="sign-up-with-facebook">Continuer avec Facebook</div>
                    </div>

            </div>

            <!-- <div class="col-12">
                <MobileFooter/>
            </div> -->

        </div>
        
</template>

<style scoped>
::v-deep .facebook-small-box-container button {
    position: relative; 
    border: none; 
    line-height: 40px;
    font-size: 18px; 
    color: #fff; 
    background-image: none; 
    background-color: #3f5795;}


.paste-image-icon {
    position: relative;
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: center top;
}

@media (max-width: 767px) {
    .paste-image-icon {
        height: 280px;
    }
}




/*@media (min-width: 1200px) {
    .signup-div {
        width:50vw !important; 
        height:100vh !important;

        object-fit: cover;
        object-position: center top;
    }
}

@media (min-width: 900px) and (max-width: 1199px) {
    .signup-div {
        position: relative;
        width:60vw !important; 
        height:100vh !important;

        object-fit: cover;
        object-position: center top;
    }
}

@media (max-width: 899px) {
    .signup-div {
        position: relative;

        object-fit: cover;
        object-position: center top;
        width:100vw !important; 
        height:auto !important;

    }
}*/

.container {
    padding: 10%;
}

.subscribe {
    font-size: 40px;
    letter-spacing: -0.4px;
    font-weight: 500;
    font-family: Poppins;
    color: #121212;
    padding-bottom: 2%;

}

@media (max-width: 767px) {
    .subscribe {
        font-size: 30px;

    }
}

@media (min-width: 800px) {
    .go-login {
        font-size: 16px;
        font-weight: 600;
        color: #121212;
        cursor: pointer;
    }

    .go-login-first {
        font-size: 16px;
        color: #121212;
        cursor: pointer;
    }
}

@media (max-width: 799px) {
    .go-login {
        font-size: 14px;
        font-weight: 600;
        color: #121212;
        cursor: pointer;
    }

    .go-login-first {
        font-size: 14px;
        color: #121212;
        cursor: pointer;
    }
}

.button1 {
    align-self: stretch;
    border-radius: 6px;
    background-color: #121212;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    padding: 10px 26px;
    cursor: pointer;
    text-align: center;
    font-size: 18px;
    color: #fff;
    font-family: 'Space Grotesk';
    width: 100%;
    margin-top: 4%;
}

.getStarted1 {
    position: relative;
    letter-spacing: -0.4px;
    line-height: 32px;
    font-weight: 500;
}

.ou {
    font-size: 16px;
    line-height: 26px;
    font-family: Inter;
    color: #121212;
    padding: 10%;

}

.small-box-container {
    position: relative;
    border-radius: 6px;
    border: 1px solid #cbcbcb;
    box-sizing: border-box;
    width: 100%;
    height: 52px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    gap: 25px;
    text-align: left;
    font-size: 14px;
    color: #3e3e59;
    font-family: Inter;
    cursor: pointer;
}

.facebook-small-box-container {
    position: relative;
    border-radius: 6px;
    box-sizing: border-box;
    width: 100%;
    height: 52px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    gap: 25px;
    text-align: left;
    font-size: 14px;
    background-color: #3f5795;
    box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.08);
    border: 1px solid #d7d7d7;
    font-family: Inter;
    cursor: pointer;
}

.icon-class {
    position: relative;
    width: 24px;
    height: 24px;
    overflow: hidden;
    flex-shrink: 0;
}

.sign-up-with {
    position: relative;
    line-height: 22px;
}

.sign-up-with-facebook {
    position: relative;
    line-height: 22px;
    color: #fff;
}
</style>

<script>
//import MobileFooter from "../../../components/mobile-login-footer"
//TODO oAuth2
import AuthApi from "@/services/auth-api";


export default ({
    name: "Account",
    props: {
        showOauth:{
          type:Boolean,
          default:false
      },
    },
    components: { /*MobileFooter*/
    },
    data(){
    return{
    }
  },


  methods: {
    getUrlGoogle(){
            AuthApi.signInWithOAuth2("google").then(
                (redirectUrl)=>{
                    if(redirectUrl){
                        window.location.href = redirectUrl 
                    }
                }
            )
        }, 

    getUrlFacebook(){
        AuthApi.signInWithOAuth2("facebook").then(
            (redirectUrl)=>{
                if(redirectUrl){
                    window.location.href = redirectUrl 
                }
            }
        )
    }, 
        
  }


})
</script>
